var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLongLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 125.44 39.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{fill:none;}.cls-9{fill:url(#linear-gradient);}.cls-2{clip-path:url(#clippath-6);}.cls-3{clip-path:url(#clippath-5);}.cls-4{clip-path:url(#clippath-3);}.cls-5{clip-path:url(#clippath-4);}.cls-6{clip-path:url(#clippath-2);}.cls-7{clip-path:url(#clippath-1);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-2);}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{fill:url(#linear-gradient-5);}.cls-16{fill:#123f51;font-family:Georgia, Georgia;font-size:24px;}.cls-8{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 40.86,
    height: 39.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4.6 8.36 3.22 14.41 20.42 1.83 20.41 .72 4.6 8.36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -850.02,
    y1: -536.47,
    x2: -849.96,
    y2: -536.47,
    gradientTransform: "translate(-223996.43 141389.38) rotate(-180) scale(263.54 -263.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a7635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4a7635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#4a7635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#4a7635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a7635"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "2.88 15 8.97 36.02 .66 25.61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -841.32,
    y1: -546.6,
    x2: -841.26,
    y2: -546.6,
    gradientTransform: "translate(107037.51 -69515.07) scale(127.22 -127.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8aa12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f59c0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f59c0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59c0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59c0b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "8.97 35.83 31.78 35.83 29.03 39.21 11.47 39.04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -849.04,
    y1: -538.67,
    x2: -848.97,
    y2: -538.67,
    gradientTransform: "translate(-296864.79 188402.44) rotate(-180) scale(349.69 -349.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdfcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#289638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2b9538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b9538"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.61 8.44 20.87 .66 20.51 1.82 37.95 14.94 36.61 8.44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -845.84,
    y1: -544.31,
    x2: -845.78,
    y2: -544.31,
    gradientTransform: "translate(226077.47 -145463.5) scale(267.26 -267.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e1e3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#1e1e3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e3f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "37.71 14.94 31.38 35.83 40.11 25.59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -844.94,
    y1: -546.3,
    x2: -844.87,
    y2: -546.3,
    gradientTransform: "translate(113170.9 -73126.24) scale(133.9 -133.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#931832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#931832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#931832"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 40.86,
    height: 39.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -846.57,
    y1: -541.81,
    x2: -846.51,
    y2: -541.81,
    gradientTransform: "translate(526367.57 -345026.05) rotate(-.63) scale(626.18 -626.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#093f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#093f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#123f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#093e51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#123f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123f50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -846.43,
    y1: -542.04,
    x2: -846.36,
    y2: -542.04,
    gradientTransform: "translate(461799.91 -295709.23) scale(545.58 -545.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#093f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#093f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#093f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#093f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#093f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093f50"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(11.32 29.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "R   esiRent")), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 3.22,
    y: 0.72,
    width: 17.2,
    height: 13.69
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 0.66,
    y: 15,
    width: 8.3,
    height: 21.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 8.97,
    y: 35.83,
    width: 22.82,
    height: 3.38
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 20.51,
    y: 0.66,
    width: 17.44,
    height: 14.28
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 31.38,
    y: 14.94,
    width: 8.74,
    height: 20.88
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "29.22 39.18 29.22 39.8 11.37 39.82 .04 25.63 4.06 7.93 20.41 .04 36.77 7.9 40.83 25.59 29.52 39.8 29.22 39.8 29.22 39.18 28.74 38.79 39.49 25.29 35.7 8.76 20.41 1.41 5.13 8.79 1.38 25.33 11.96 38.58 29.22 38.56 29.22 39.18 28.74 38.79 29.22 39.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "20.42 1.83 20.71 1.44 38.19 14.21 32.16 36.31 8.59 36.31 2.66 14.21 20.42 1.23 20.71 1.44 20.42 1.83 20.71 2.23 3.78 14.61 9.34 35.34 31.41 35.34 37.07 14.61 20.13 2.23 20.42 1.83 20.71 2.23 20.42 1.83"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongLogoDark);
export default __webpack_public_path__ + "static/media/Long_logo_dark.814e4db4152f23713c9f5175266aca41.svg";
export { ForwardRef as ReactComponent };